import { routeNames } from "constant/routes";

export const RELATED_ENTITY_PERMISSION_BY_KIND = {
  contact: "contact_permission",
  company: "company_permission",
  document: "document_permission",
  product: "product_service_permission"
};

const KIND_TO_ROUTE = {
  contact: routeNames.APP_CONTACTS,
  company: routeNames.APP_COMPANIES,
  document: routeNames.APP_DOCUMENTS,
  product: routeNames.APP_PRODUCTS_SERVICES
};

/**
 * Build a detail URL for a related entity, preferring Edit over View-only.
 * @param {'contact'|'company'|'document'|'product'} kind
 * @param {string|number} id
 * @param {{ Edit?: boolean, View?: boolean }} permissions
 * @returns {string}
 */
export function getEntityDetailUrl(kind, id, permissions) {
  if (id == null || id === "" || !kind) {
    return "";
  }

  const baseRoute = KIND_TO_ROUTE[kind];
  if (!baseRoute) {
    return "";
  }

  if (permissions?.Edit) {
    return `${baseRoute}/${id}`;
  }
  if (permissions?.View) {
    return `${baseRoute}/${id}/view`;
  }
  return "";
}
